import React, { memo } from "react";
import Button from "react-bootstrap/Button";
import LazyLoad from "react-lazyload";
import "./styles.scss";
import { useNavigate } from "react-router-dom";
import { isEmpty } from "lodash";
import OptionsMenu from "../OptionsMenu";
import { getValidOptionsList } from "../DataTable";

const ClassroomCard = ({
  classroomName = "",
  category = "",
  id = "",
  classroomThumbnail = "",
  roleOfTheUser = "",
  optionsMenuList,
  permissions,
  isPermissionApplied,
  userId,
  classroom = "",
  showOrHideClassroomHandler = () => {},
}) => {
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_API_URL;
  const userUrl = BASE_URL?.split("/api/v1")[0];

  return (
    <div className="classroom-card">
      <LazyLoad height={20} offset={100}>
        <img
          className="classroom-card-img"
          src={
            !isEmpty(classroomThumbnail)
              ? `${userUrl}${classroomThumbnail}`
              : "/Course Images.svg"
          }
          alt="classroom-thumbnail"
        />
      </LazyLoad>
      <div className="classroom-card-content">
        <div style={{ display: "flex", marginBottom: "6px" }}>
          <div className="classroom-card-category">{category}</div>
        </div>
        <div className="classroom-card-title">{classroomName}</div>
      </div>
      <hr style={{ marginTop: "0px", marginBottom: "0px" }} />
      <div className="classroom-card-footer">
        <Button
          className="start-classroom-styles"
          variant="outline-primary"
          onClick={() => {
            navigate(
              `${
                roleOfTheUser === "Student" ? "/student" : ""
              }/myClassrooms/${id}/dashboard`
            );
          }}
        >
          {roleOfTheUser === "Student" ? "Start Learning" : "Start Teaching"}
        </Button>
        {/* <div className="complete-percentage-styles">
          {progressPercentage}% Completed
        </div> */}
        {optionsMenuList &&
          roleOfTheUser !== "Student" &&
          getValidOptionsList(
            optionsMenuList,
            permissions,
            userId,
            classroom?.createdBy,
            isPermissionApplied
          ).length && (
            <OptionsMenu
              optionsList={[
                ...getValidOptionsList(
                  optionsMenuList,
                  permissions,
                  userId,
                  classroom?.createdBy,
                  isPermissionApplied
                ),
                ...(roleOfTheUser === "Root"
                  ? [
                      {
                        text: classroom?.showOnWebsite
                          ? "Hide on Website"
                          : "Show on Website",
                        actionsHandler: () => {
                          showOrHideClassroomHandler(classroom);
                        },
                        imgSrc: "/deleteIcon.svg",
                        imgAltText: "delete-icon",
                      },
                    ]
                  : []),
              ]}
              passedData={classroom._id}
              row={classroom}
            />
          )}
      </div>
    </div>
  );
};

export default memo(ClassroomCard);
